export default "__VITE_ASSET__DrkwKBC2__"